import React from "react";
import { Nav } from "components/legal";

import * as styles from "./LegalPageLayout.module.scss";

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  desc?: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  desc,
  title,
  children,
  lastUpdated,
}) => {
  return (
    <section className={styles.LegalPageLayout}>
      <Nav />
      <section>
        <header className={styles.LegalPageLayout_header}>
          <h1 className={styles.LegalPageLayout_header_title}>{title}</h1>
          <p className={styles.LegalPageLayout_header_date}>
            Last Updated: {lastUpdated}
          </p>
        </header>
        <main>
          <div className={styles.LegalPageLayout_main_desc}>{desc}</div>
          {children}
        </main>
      </section>
    </section>
  );
};

export default LegalPageLayout;
